import { useTranslation } from "react-i18next";
import { Button } from "../../ui/index.js";

/** Кнопки внизу шага: «Назад» и «Далее» (или своя подпись), плюс «Пропустить» для необязательных шагов. */
export function StepNav({
  onBack,
  onNext,
  onSkip,
  nextLabel,
  disabled,
  busy,
}: {
  onBack?: () => void;
  onNext: () => void;
  onSkip?: () => void;
  nextLabel?: string;
  disabled?: boolean;
  busy?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="mt-6 space-y-2 lg:flex lg:items-center lg:gap-2 lg:space-y-0">
      <div className="flex gap-2">
        {onBack && (
          <Button variant="secondary" onClick={onBack} disabled={busy}>
            {t("common.back")}
          </Button>
        )}
        <Button className="flex-1 lg:flex-none lg:px-8" onClick={onNext} disabled={disabled || busy}>
          {busy ? t("common.loading") : (nextLabel ?? t("onb.next"))}
        </Button>
      </div>
      {onSkip && (
        <Button variant="ghost" className="w-full lg:w-auto" onClick={onSkip} disabled={busy}>
          {t("onb.skip")}
        </Button>
      )}
    </div>
  );
}
